module.exports = __webpack_public_path__ + "img/studyBackGround.6aa1c1b5.png";